import { PartnerCustomerListItemModel } from '@bn/openapi/partner-portal';

export const hasContractDates = (customer: PartnerCustomerListItemModel | null | undefined): boolean =>
  !!customer?.ContractStartDate && !!customer?.ContractEndDate;

export const isContractActive = (customer: PartnerCustomerListItemModel | null | undefined): boolean => {
  if (!hasContractDates(customer)) {
    return false;
  }

  const start = new Date(customer?.ContractStartDate ?? '').getTime();
  const end = new Date(customer?.ContractEndDate ?? '').getTime();
  const now = Date.now();

  return !Number.isNaN(start) && !Number.isNaN(end) && start <= now && now <= end;
};
